import { RENOVATIONS_RECIEVED, RENOVATION_SAVED, RENOVATION_DELETED, RENOVATION_UNLOADED } from './types'

export default function renovations(state = [], action = {}){
  switch (action.type) {
    case RENOVATIONS_RECIEVED:
      return action.data.sort(function(a, b) {
        let result = 0 
        let aStart = a.bars && a.bars[0] ? parseInt(a.bars[0].startDate, 10) : 0
        let bStart = b.bars && b.bars[0] ? parseInt(b.bars[0].startDate, 10) : 0
        let aValue = a.bars && a.bars[0] ? parseInt(a.bars[0].value, 10) : 0
        let bValue = b.bars && b.bars[0] ? parseInt(b.bars[0].value, 10) : 0
        result = (a.linkedToID - b.linkedToID) || (aStart-bStart) || (bValue - aValue) || (a.description.localeCompare(b.description))
        return result
      })
    case RENOVATION_UNLOADED:
      return []
    case RENOVATION_SAVED:
    let isEdit = false
    const _state = state.map( v => {
      if(v.id === action.data.id){
        isEdit = true
        return action.data
      }else{
        return v
      }
    })
    if(!isEdit){
      return [action.data, ...state]
    }else{
      return _state
    }
    case RENOVATION_DELETED:
      return state.filter( v => v.id !== action.data.id )
    default:
      return state
  }
}
